<div *ngIf="field && profileCustomField">
  <ng-container *ngIf="showHeader">
    <span class="custom-field-label">{{ profileCustomField.FieldName }}</span>
    <span class="custom-field-description">{{ field.Descr }}</span>
  </ng-container>
  <div class="mct-flex mct-row mct-justify-start mct-items-center">
    <div [ngSwitch]="field.DataType">
      <div *ngSwitchCase="'String'">
        <div [ngSwitch]="field.DisplayType">
          <div *ngSwitchCase="'Drop Down List'">
            <p-select
              appendTo="body"
              optionLabel="FieldValue"
              dataKey="CustomFieldValueID"
              placeholder="{{ 'invoices.invoice-builder.select-label' | translate }}"
              [options]="customFieldValues"
              [(ngModel)]="selectedDropdownItem"
              [style]="{ 'max-width': '200px' }"
              [disabled]="!editable"
              (onChange)="onFieldChange()"
            ></p-select>
          </div>
          <div *ngSwitchCase="'Textbox - Singleline'">
            <input [disabled]="!editable" type="text" [(ngModel)]="profileCustomField.FieldValue" (change)="onFieldChange()" />
          </div>
          <div *ngSwitchCase="'Textbox - Multiline'">
            <textarea
              [disabled]="!editable"
              pInputTextArea
              [(ngModel)]="profileCustomField.FieldValue"
              (change)="onFieldChange()"
            ></textarea>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="'Date'">
        <p-datepicker
          appendTo="body"
          [(ngModel)]="profileCustomField.FieldValue"
          [disabled]="!editable"
          [showIcon]="true"
          (onSelect)="onFieldChange()"
        ></p-datepicker>
      </div>
      <div *ngSwitchDefault>
        <input type="number" [(ngModel)]="profileCustomField.FieldValue" [disabled]="!editable" (change)="onFieldChange()" />
      </div>
    </div>
    <button
      *ngIf="editable && showDelete"
      class="btn btn-danger"
      type="button"
      (click)="delete.emit()"
      title="{{ 'common.delete' | translate | titlecase }}"
    >
      {{ 'common.delete' | translate | titlecase }}
    </button>
  </div>
</div>
